export const COMPONENTS = {
  ANCHOR: 'anchor',
  ANCHOR_ITEM: 'anchor.anchorItem',
  OVERVIEW: 'overview',
  OVERVIEW_ITEM: 'overview.overviewItem',
  OVERVIEW_ITEM_HEADER: 'overview.overviewItem.header',
  OVERVIEW_ITEM_HIGHLIGHTS: 'overview.overviewItem.highlights',
  OVERVIEW_ITEM_OPINION: 'overview.overviewItem.opinion',
  OVERVIEW_ITEM_CTA: 'overview.overviewItem.cta',
  OVERVIEW_ITEM_LEARN_MORE: 'overview.overviewItem.learnMore',
  OVERVIEW_ITEM_VERDICT: 'overview.overviewItem.verdict',
  OVERVIEW_ITEM_EXTRACT: 'overview.overviewItem.extract',
  INVENTORY: 'inventory',
  VIN: 'vin',
  DEALERSHIP: 'dealership',
  DEALERSHIP_ITEM: 'dealership.dealershipItem',
  LINKS: 'links',
  LINKS_ITEM: 'links.linksItem',
  BUBBLE: 'bubble',
  ANSWER: 'answer',
};
